<template>
  <div class="wrap">
    <h2 class="common-header">{{ $t('203') }}</h2>
    <el-tabs v-model="activeName">
      <el-tab-pane v-for="item in categoryConfig" :key="item.label" :label="item.name" :name="item.label">
        <Content v-if="activeName === item.label" :category="item.label" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { categoryConfig } from './config'
import Content from './content.vue'
export default {
  components: { Content },
  data() {
    return {
      categoryConfig: categoryConfig(this),
      // 1 普通消息  4 签字消息
      activeName: '1'
    }
  }
}
</script>
